(function () {
  var TARGET = 5.2;   // AA is 4.5; the margin absorbs backdrop rounding
  var scheduled = false;

  var SELECTORS = [
    '.variant-card-badge',
    '.bnpl-inline__brand', '.bnpl-inline__btn', '.bmp-area-label',
    '.spxs__eyebrow',
    '.gm3lib__tab', '.gm3lib__intro', '.gm3lib__cap',
    '.gm3ct__eyebrow', '.gm3ct__note', '.gm3ct__intro',
    '.gm3hl__note', '.gm3hl__sub', '.gm3hl__copy',
    '.gm3ft__intro', '.gm3ft__text',
    '.calculator-eu-card__label', '.calculator-eu-card__description', '.calculator-eu-card__step-indicator',
    '.calculator-uk-card__label', '.calculator-uk-card__description', '.calculator-uk-card__step-indicator',
    '.calculator-au-card__label', '.calculator-au-card__description', '.calculator-au-card__step-indicator',
    '.calculator-nz-card__label', '.calculator-nz-card__description', '.calculator-nz-card__step-indicator',
    '.pw-eyebrow', '.pw-note', '.pw-lede', '.pw-label',
    'variant-selects label', '.product-form__input label',
    '.ultra-itb__eyebrow',
    '.nano-eyebrow', '.nano-lede', '.nano-tile__sub',
    '.index-image-swiper--text p', '.widget p a', '.custom-text-with-icons--content'
  ].join(',');

  function lum(c) {
    var s = c.map(function (v) {
      v /= 255;
      return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
    });
    return 0.2126 * s[0] + 0.7152 * s[1] + 0.0722 * s[2];
  }
  function rgba(s) {
    var m = /rgba?\(([^)]+)\)/.exec(s || '');
    if (!m) return null;
    var p = m[1].split(',').map(parseFloat);
    return { c: [p[0], p[1], p[2]], a: p.length > 3 ? p[3] : 1 };
  }
  function ratio(a, b) {
    var x = lum(a), y = lum(b);
    return (Math.max(x, y) + 0.05) / (Math.min(x, y) + 0.05);
  }
  // Composite every translucent layer between the element and the first opaque
  // ancestor, so a 4% overlay is not mistaken for solid black.
  function bgOf(el) {
    var stack = [], n = el;
    while (n && n !== document.documentElement) {
      var v = rgba(getComputedStyle(n).backgroundColor);
      if (v && v.a > 0) {
        stack.push(v);
        if (v.a >= 0.999) break;
      }
      n = n.parentElement;
    }
    var base = [255, 255, 255];
    for (var i = stack.length - 1; i >= 0; i--) {
      var v = stack[i];
      base = [0, 1, 2].map(function (k) {
        return Math.round(v.c[k] * v.a + base[k] * (1 - v.a));
      });
    }
    return base;
  }
  function nudge(fg, bg) {
    var target = lum(bg) > 0.5 ? [0, 0, 0] : [255, 255, 255];
    for (var t = 0.05; t <= 1.001; t += 0.05) {
      var c = [0, 1, 2].map(function (i) { return Math.round(fg[i] + (target[i] - fg[i]) * t); });
      if (ratio(c, bg) >= TARGET) return c;
    }
    return target;
  }


  // Links whose only content is an image or an icon reach the tab order with
  // no accessible name. Rather than guessing one label, derive it from what is
  // actually next to the link: the image alt, the card's own heading, or a
  // known destination.
  function labelLinks() {
    var as = document.querySelectorAll('a[href]:not([data-a11y-named])');
    for (var i = 0; i < as.length; i++) {
      var a = as[i];
      a.setAttribute('data-a11y-named', '1');
      if ((a.textContent || '').trim()) continue;
      if ((a.getAttribute('aria-label') || '').trim()) continue;
      if ((a.getAttribute('title') || '').trim()) continue;
      var img = a.querySelector('img[alt]');
      if (img && (img.getAttribute('alt') || '').trim()) continue;

      var href = a.getAttribute('href') || '';
      var label = '';
      if (/play\.google\.com/.test(href)) label = 'Get the Speediance app on Google Play';
      else if (/apps\.apple\.com/.test(href)) label = 'Get the Speediance app on the App Store';
      if (!label) {
        var card = a.closest('article, li, .card, section, div');
        var h = card && card.querySelector('h1,h2,h3,h4,h5,h6');
        if (h && (h.textContent || '').trim()) label = (h.textContent || '').trim().slice(0, 80);
      }
      if (!label && href && href !== '#') {
        try {
          var p = new URL(href, location.href).pathname.replace(/^\/|\/$/g, '');
          if (p) label = p.split('/').pop().replace(/[-_]+/g, ' ');
        } catch (e) {}
      }
      if (label) a.setAttribute('aria-label', label.charAt(0).toUpperCase() + label.slice(1));
    }
  }


  // Decorative labels that are marked up as headings and skip levels. Removing
  // them from the heading outline fixes the order without touching the text.
  function demoteDecorativeHeadings() {
    var els = document.querySelectorAll('h4.wait-animate-text, h5.wait-animate-text, h6.wait-animate-text');
    for (var i = 0; i < els.length; i++) {
      if (els[i].getAttribute('role') !== 'presentation') {
        els[i].setAttribute('role', 'presentation');
      }
    }
  }


  // A select with no associated label is unusable with a screen reader. Take
  // the name from the visible label the design already shows next to it, and
  // only fall back to the field id if there is nothing better.
  function labelSelects() {
    // Selects, plus any text-entry control. Buttons, hidden fields and
    // checkboxes are excluded: their names come from elsewhere.
    var sels = document.querySelectorAll(
      'select:not([data-a11y-named]), textarea:not([data-a11y-named]), '
      + 'input:not([data-a11y-named]):not([type="hidden"]):not([type="submit"])'
      + ':not([type="button"]):not([type="checkbox"]):not([type="radio"]):not([type="image"])');
    for (var i = 0; i < sels.length; i++) {
      var s = sels[i];
      s.setAttribute('data-a11y-named', '1');
      if ((s.getAttribute('aria-label') || '').trim()) continue;
      if (s.getAttribute('aria-labelledby')) continue;
      if (s.id && document.querySelector('label[for="' + CSS.escape(s.id) + '"]')) continue;
      if (s.closest('label')) continue;

      var label = '';
      var row = s.closest('.calculator-eu-card__row, .calculator-uk-card__row, .calculator-au-card__row, .calculator-nz-card__row, .select-field-wrapper, div');
      var cand = row && row.querySelector('label, [class*="card__label"], [class*="area-label"]');
      if (cand && (cand.textContent || '').trim()) label = (cand.textContent || '').trim();
      if (!label) {
        var prev = s.previousElementSibling;
        while (prev && !label) {
          if ((prev.textContent || '').trim()) label = (prev.textContent || '').trim();
          prev = prev.previousElementSibling;
        }
      }
      if (!label) label = (s.getAttribute('name') || s.id || 'option').replace(/[-_]+/g, ' ');
      s.setAttribute('aria-label', label.slice(0, 80));
    }
  }

  function fix() {
    scheduled = false;
    labelLinks();
    labelSelects();
    demoteDecorativeHeadings();

    var imgs = document.querySelectorAll('.variant-card__image img:not([alt])');
    for (var i = 0; i < imgs.length; i++) imgs[i].setAttribute('alt', '');

    var links = document.querySelectorAll('a[aria-label]:not([href])');
    for (var j = 0; j < links.length; j++) {
      var a = links[j];
      if ((a.textContent || '').trim()) a.removeAttribute('aria-label');
      else if (!a.getAttribute('role')) a.setAttribute('role', 'button');
    }

    var els = document.querySelectorAll(SELECTORS);
    for (var k = 0; k < els.length; k++) {
      var el = els[k];
      if (el.getAttribute('data-a11y-contrast') === '1') continue;
      if (!(el.textContent || '').trim()) continue;
      var cs = getComputedStyle(el);
      el.setAttribute('data-a11y-contrast', '1');
      if (parseFloat(cs.opacity) < 1) el.style.setProperty('opacity', '1', 'important');
      var fgv = rgba(cs.color);
      if (!fgv || fgv.a === 0) continue;
      var bg = bgOf(el);
      var fg = fgv.a >= 0.999 ? fgv.c : [0, 1, 2].map(function (n) {
        return Math.round(fgv.c[n] * fgv.a + bg[n] * (1 - fgv.a));
      });
      if (ratio(fg, bg) >= TARGET) continue;
      var c = nudge(fg, bg);
      el.style.setProperty('color', 'rgb(' + c.join(',') + ')', 'important');
    }
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    (window.requestAnimationFrame || window.setTimeout)(fix, 0);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fix);
  else fix();

  var mo;
  try {
    mo = new MutationObserver(schedule);
    mo.observe(document.documentElement, { childList: true, subtree: true });
  } catch (e) {}

  window.addEventListener('load', function () {
    fix();
    setTimeout(function () { if (mo) mo.disconnect(); }, 5000);
  });
})();
